import React from 'react';
import { Link } from 'react-router-dom';
import Introduction from './Introduction';


export default function Home() {
  return (
    <div>
      <Introduction />

      <section className="featured-ios-section">
        <h2 className="text-4xl font-bold pb-3">
          Featured iOS Applications
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-10 px-6">
          Production native iOS applications built, tested, shipped, and
          maintained from concept through App Store release.
        </p>

        <div className="featured-ios-grid">

          <div className="featured-ios-card">
            <h3 className="text-2xl font-bold">
              True Lock Tuner
            </h3>

            <p className="project-tech">
              Swift • SwiftUI • AVFoundation • StoreKit 2
            </p>

            <p>
              Production guitar tuning and practice application featuring
              real-time audio processing, pitch detection, chord recognition,
              premium features, analytics, and App Store distribution.
            </p>

            <div className="featured-project-links">
              <Link to="/project1">
                View Case Study
              </Link>

              <a
                href="https://apps.apple.com/us/app/guitar-tuner-true-lock-tuner/id6761863778"
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
            </div>
          </div>


          <div className="featured-ios-card">
            <h3 className="text-2xl font-bold">
              SnoozeLock
            </h3>

            <p className="project-tech">
              Swift • SwiftUI • AlarmKit • CoreMotion • StoreKit 2
            </p>

            <p>
              Production alarm application featuring challenge-driven alarm
              dismissal, motion-based step counting, barcode scanning,
              state-driven workflows, and native device integrations.
            </p>

            <div className="featured-project-links">
              <Link to="/project2">
                View Case Study
              </Link>

              <a
                href="https://apps.apple.com/app/snoozelock-alarm-clock/id6785264664"
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
            </div>
          </div>

        </div>
      </section>


      <section className="home-about">
        <h2 className="text-3xl font-bold pb-4">
          About
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-6">
          I build native iOS products with a focus on practical engineering,
          real-world device behavior, product ownership, and shipping software
          that people can actually use.
        </p>

        <Link to="/about" className="home-about-link">
          More About Me
        </Link>
      </section>

      
    </div>
  );
}